import { apiSlice } from "./apiSlice";
import { RAZORPAY_PAYMENT } from "../constants";

const razorpayPaymentApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createRazorpayOrder: builder.mutation({
      query: (data) => ({
        url: `${RAZORPAY_PAYMENT}/createRazorpayOrder`,
        method: "POST",
        body: data.payload,
        headers: {
          Authorization: `Bearer ${data.token}`,
        },
      }),
    }),
    verifyRazorpayPayment: builder.mutation({
      query: (data) => ({
        url: `${RAZORPAY_PAYMENT}/verifyRazorpayPayment`,
        method: "POST",
        body: data.payload,
        headers: {
          Authorization: `Bearer ${data.token}`,
        },
      }),
    }),
    razorpayUserDropped: builder.mutation({
      query: (data) => ({
        url: `${RAZORPAY_PAYMENT}/razorpayUserDropped`,
        method: "POST",
        body: data.payload,
        headers: {
          Authorization: `Bearer ${data.token}`,
        },
      }),
    }),
  }),
});

export const {
  useCreateRazorpayOrderMutation,
  useVerifyRazorpayPaymentMutation,
  useRazorpayUserDroppedMutation,
} = razorpayPaymentApiSlice;
